export function useRedirect() {
  return {
    toLogin(loginUrl: string) {
      window.location.replace(loginUrl);
    },
    to401() {
      setTimeout(() => {
        window.location.replace('401.html');
      }, 500);
    },
    to403() {
      setTimeout(() => {
        window.location.replace('403.html');
      }, 500);
    },
    toError() {
      setTimeout(() => {
        window.location.replace('error.html');
      }, 500);
    }
  };
}
